import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { determinarPaginaAtualCupons} from '../../actions/cupom/cuponsActions'
import BotoesPaginacao from '../comum/BotoesPaginacao'

export class BotoesPaginacaoCupom extends Component {
  render () {
    return <BotoesPaginacao
      numeroElementos={this.props.total}
      paginaAtual={this.props.paginaAtual}
      registrosPorPagina={this.props.registrosPorPagina}
      determinarPaginaAtual={this.props.determinarPaginaAtualCupons}/>
  }
}

export function mapStateToProps (state) {
  return {
    paginaAtual: state.cupom.paginaAtualCupons,
    total: state.cupom.total,
    registrosPorPagina: state.cupom.registrosPorPaginaCupons
  }
}

export function mapDispatchToProps (dispatch) {
  return bindActionCreators({ determinarPaginaAtualCupons }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(BotoesPaginacaoCupom)
